export default __webpack_public_path__ + "static/media/logo_vertical.dce7e8e2.png";